import { Form, Grid, Select, TextField } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { countries } from '../../EditCounterpartyPaymentDetailsPopupContent.constants';
import { useRequiredFields } from './ThirdStep.hooks';
import { messages } from './ThirdStep.messages';
import { ThirdStepProps } from './ThirdStep.types';

export const ThirdStep = memo<ThirdStepProps>((props) => {
    const { requirements } = props;

    const requiredFields = useRequiredFields(requirements);

    return (
        <Form.Part>
            <Grid gridTemplateColumns='repeat(2, 1fr)' gap='16px'>
                {requiredFields.map((field) => {
                    if (field.name === 'payerBankCountry') {
                        return (
                            <Select
                                key={field.name}
                                name={field.name}
                                label={field.title}
                                items={countries}
                                required
                                disabled={field.disabled}
                            />
                        );
                    }

                    return (
                        <TextField
                            key={field.name}
                            name={field.name}
                            label={field.title}
                            placeholder={messages.inputPlaceholder}
                            required
                            disabled={field.disabled}
                            pattern={
                                field.validationRegExp
                                    ? {
                                          value: field.validationRegExp,
                                          message: messages.validationErrorMessage,
                                      }
                                    : undefined
                            }
                        />
                    );
                })}
            </Grid>
        </Form.Part>
    );
});

ThirdStep.displayName = 'ThirdStep';
